import { render } from "./FilterPopover.vue?vue&type=template&id=a0c748b6&ts=true"
import script from "./FilterPopover.vue?vue&type=script&lang=ts"
export * from "./FilterPopover.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__